import { FolderKanban, Gauge, TriangleAlert } from "lucide-react";
import { defineFeature } from "../types";

/**
 * Projects — delivery boards, milestones, the team and retainer deliverable
 * quotas. PRD §7 Item 3 (US-3.1, US-3.5, US-3.6).
 *
 * `/projects/:id` is fixed by ENTITY_ROUTES: search results, notifications and
 * e-mails link there, so the route must serve that exact project.
 */
export default defineFeature({
  key: "projects",
  title: "Projects",
  entities: ["project"],
  routes: [
    { path: "projects", lazy: () => import("./page") },
    { path: "projects/:id", lazy: () => import("./detail") },
  ],
  nav: [
    {
      label: "Projects",
      to: "/projects",
      icon: FolderKanban,
      group: "delivery",
      order: 10,
      permission: "projects:read",
      description: "Boards, milestones and retainer deliverables",
    },
  ],
  quickCreate: [
    {
      key: "project",
      label: "Project",
      icon: FolderKanban,
      to: "/projects?new=1",
      permission: "projects:write",
      order: 20,
      description: "A retainer, a campaign or an internal build",
    },
  ],
  commands: [
    {
      key: "projects.portfolio",
      label: "Delivery portfolio",
      icon: Gauge,
      to: "/projects?view=board",
      group: "navigate",
      permission: "projects:read",
      keywords: ["health", "monday", "status"],
    },
    {
      key: "projects.at-risk",
      label: "Show projects at risk",
      icon: TriangleAlert,
      to: "/projects?view=board&health=at_risk&health=off_track",
      group: "actions",
      permission: "projects:read",
      keywords: ["off track", "escalate", "red"],
    },
    {
      key: "projects.no-update",
      label: "Projects with no status update this week",
      icon: TriangleAlert,
      to: "/projects?view=board&needsStatusUpdate=true",
      group: "actions",
      permission: "projects:read",
      keywords: ["stale", "silent", "friday"],
    },
  ],
});
